import PlateMappingContainer from './PlateMappingContainer';

export default function PlateExperimentEditor({
  selectedExperimentId, state,set
}){

  let exp = state.experiments[selectedExperimentId];

  return (
    <div style={{borderLeft:'1px solid #ccc', padding:5}}>
      <PlateMappingContainer {...{
        globalSet:set,
        globalState:state,
        experimentId:selectedExperimentId,
        experiment:exp
      }}/>
    </div>
  )


}
